import DetailCard from 'components/DetailCard';
import { useOutletContext } from 'react-router-dom';

interface RunHealthCheckContext {
  run?: any;
}

export default function RunHealthCheck() {
  const { run } = useOutletContext<RunHealthCheckContext>();

  return (
    <div>
      <DetailCard label="Status">{run?.run_status}</DetailCard>
    </div>
  );
}
